<template>
    <div class="">
        <div class="row" v-if="!isUnassignedPopout">
            <div class="col-12 col-lg-3">
                <div class="mb-3 bg-white rounded-1 p-2">
                    <div class="d-flex justify-content-between">
                        <button
                            v-if="!isYesterday"
                            class="btn btn-secondary me-2 w-50"
                            @click="setDate(yesterday)"
                        >
                            <i class="fa fa-arrow-left"></i> Yesterday
                        </button>

                        <button
                            v-if="!isToday"
                            class="btn btn-secondary w-50"
                            :class="{ 'me-2': isYesterday, 'ms-2': isTomorrow }"
                            @click="setDate(today)"
                        >
                            Today
                        </button>

                        <button
                            v-if="!isTomorrow"
                            class="btn btn-secondary btn-sm ms-2 w-50"
                            @click="setDate(tomorrow)"
                        >
                            Tomorrow <i class="fa fa-arrow-right"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-6">
                <div class="mb-3 bg-white rounded-1 p-2">
                    <div class="d-flex justify-content-between">
                        <div>
                            <a :href="generateMapViewRoute()" class="btn btn-secondary me-2">
                                <i class="fa fa-map-marker me-2"></i> Map View
                            </a>
                            <a :href="generateExportRoute()" class="btn btn-secondary ms-2">
                                <i class="fa fa-print me-2"></i> Print/Export
                            </a>
                        </div>
                        <div>
                            <a :href="generateMessagesToDriversRoute()" class="btn btn-secondary">
                                <i class="fa fa-mobile-alt me-2"></i> Messages to Drivers
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-3">
                <div class="mb-3 bg-white rounded-1 p-2">
                    <div class="form-group">
                        <div class="input-group">
                        <span class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </span>
                            <input class="form-control js-flatpickers"
                                   placeholder="yyyy-mm-dd"
                                   id="date_calendar"
                                   name="date_calendar"
                                   ref="date_calendar"
                                   v-model="internalDate"
                                   type="date"
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Alerts -->
        <div class="row" v-if="!isUnassignedPopout">
            <div class="col-12">
                <AdminBlock class="bg-danger text-white text-center mb-4">
                    <strong>Please allow pop up windows</strong>
                </AdminBlock>
            </div>

            <div class="col-12" v-if="isInPast">
                <AdminBlock class="bg-warning text-white text-center">
                    <strong>These Movements are in the past, therefore you cannot change them</strong>
                </AdminBlock>
            </div>

            <div class="col-12" v-if="isInFuture">
                <AdminBlock class="bg-warning text-white text-center">
                    <strong>These Movements are in the future, you will not be notified a Driver has read them until this day</strong>
                </AdminBlock>
            </div>
        </div>

        <div class="row mb-3" v-if="!isUnassignedPopout">
            <div class="col-lg-3 offset-lg-4 m-b-md">

                <!-- ToDo: Add published code -->

                <div class="form-check form-switch">
                    <input
                        id="switch"
                        class="form-check-input me-4"
                        type="checkbox"
                        v-model="isPublished"
                        @change="togglePublish"
                    />
                    <label class="form-check-label" for="switch">
                        {{ isPublished ? 'Published' : 'Unpublished' }}
                    </label>
                </div>

            </div>

            <div class="col-lg-4 offset-lg-1 m-b-md">
                <p class="text-end mb-0">
                    <span class="transported bg-success"
                          style="border-radius:30px;display:inline-block;height:15px;margin-right:10px;width:100px"></span>
                    Transported
                    <span class="bg-black"
                          style="border-radius:30px;display:inline-block;height:15px;margin-right:10px;margin-left:50px;width:100px"></span>
                    Driven
                </p>
            </div>
        </div>

        <div class="row">
            <div :class="isUnassignedPopout ? 'col-12' : 'col-12 col-lg-3 pe-0'">
                <AdminBlock
                    v-show="unassignedView || !hideUnassignedMovements"
                    title="Unassigned Movements"
                    :slim="true"
                >
                    <template #options>
                        <button
                            v-if="!isUnassignedPopout"
                            type="button"
                            class="btn btn-secondary btn-sm"
                            @click="openUnassignedMovementsPopout"
                        >
                            <i class="fa fa-external-link-alt me-2"></i>
                            Pop Out
                        </button>
                    </template>

                    <template #heading >
                        <button
                            v-if="isInPast"
                            type="button"
                            class="btn btn-success w-100"
                            style="height: 3rem;"
                            @click="showModal()">
                            Move to Today
                        </button>
                    </template>

                    <DriverDropzone
                        v-model="unassignedMovements"
                        :driver="{
                            id: 0,
                            name: 'Unassigned',
                            has_left: false
                        }"
                        :show-title="false"
                        :show-counts="showCounts"
                        :compact-grid="isUnassignedPopout"
                        :date="internalDate"
                        sort-alpha
                    />
                </AdminBlock>
            </div>

            <div v-show="!isUnassignedPopout" class="col-12" :class="!isUnassignedPopout && !hideUnassignedMovements ? 'col-lg-9' : ''">
                <div class="block block-rounded">
                    <div class="p-3">
                        <div class="tab-pane active" id="drivers" role="tabpanel"
                             aria-labelledby="drivers-tab">
                            <div class="row g-3">
                                <div class="col-12 col-sm-6 col-xl-4" v-for="driver in drivers" :key="driver.id">
                                    <DriverDropzone
                                        :model-value="assignedMovements[driver.id] ?? []"
                                        :key="driver.id"
                                        :driver="driver"
                                        :date="internalDate"
                                        :show-counts="showCounts"
                                        @update:model-value="assignedMovements[driver.id] = $event"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div ref="modal" class="modal" id="move_to_today_modal_movement_modal" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-center">
                            Past Unassigned Movements
                        </h5>
                        <button
                            type="button"
                            class="btn-close"
                            aria-label="Close"
                            data-bs-dismiss="modal"
                        ></button>
                    </div>

                    <div class="modal-header block-header-default border-bottom py-3">
                        <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2 w-100">
                            <p class="mb-0">
                                Please select all Movements you wish to move to today
                            </p>
                            <button
                                type="button"
                                class="btn btn-secondary btn-sm flex-shrink-0"
                                @click="selectAllMovements()"
                            >
                                <i class="fa fa-check me-2"></i>
                                {{ selectText }}
                            </button>
                        </div>
                    </div>

                    <div class="modal-body bg-light overflow-y-auto">
                        <div
                            v-for="(movementArray, key, index) in unassignedMovementsGroupedByDate"
                            :key="key"
                            :class="{ 'mb-4': index !== Object.keys(unassignedMovementsGroupedByDate).length - 1 }"
                        >
                            <AdminBlock
                                :title="'Unassigned Movements for ' + formatDate(key)"
                                class="mb-0"
                            >
                                <template v-slot:options>
                                    <button
                                        type="button"
                                        class="btn btn-secondary btn-sm"
                                        @click="selectSpecificDateMovements(key)"
                                    >
                                        <i class="fa fa-check me-2"></i>
                                        Select All
                                    </button>
                                </template>

                                <div class="table-responsive">
                                    <table class="table table-striped mb-0">
                                        <thead>
                                        <tr>
                                            <th style="width: 50px"></th>
                                            <th class="text-nowrap">Customer</th>
                                            <th class="text-nowrap">Job</th>
                                            <th class="text-nowrap">Collection Date</th>
                                            <th class="text-nowrap">Collection Location</th>
                                            <th class="text-nowrap">Delivery Location</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="movement in movementArray" :key="movement.id">
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    ref="movementCheckbox"
                                                    :data-date="key"
                                                    :value="parseInt(movement.id)"
                                                    v-model="selectedMovements"
                                                >
                                            </td>
                                            <td>
                                                <a v-if="movement?.job?.customer" :href="generateCustomerRoute( movement.job.customer.id )">
                                                    {{ movement?.job?.customer?.name || 'Customer name not set' }}
                                                </a>
                                                <p v-else class="mb-0">Customer not set</p>
                                            </td>
                                            <td>
                                                <a v-if="movement?.job" :href="generateJobRoute( movement.job.id )">
                                                    {{ movement?.job?.reference || 'Job reference not set' }}
                                                </a>
                                            </td>
                                            <td>
                                                <div class="d-flex align-items-center flex-wrap gap-2">
                                                    <div>
                                                        {{ formatDate(movement.collection_date) }}
                                                    </div>
                                                    <TimeLabel v-if="movement.collection_time" :time="movement.collection_time" />
                                                </div>
                                            </td>
                                            <td>
                                                {{ movement.collection_location }}
                                            </td>
                                            <td>
                                                {{ movement.delivery_location }}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </AdminBlock>
                        </div>
                    </div>

                    <div class="modal-footer border-top gap-2">
                        <button type="button"
                                :id="'move_to_today_close_button'"
                                class="btn btn-secondary"
                                data-bs-dismiss="modal"
                        >Close</button>

                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="moveUnassignedMovementsToToday()"
                        >Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.movement-droppable .droppable {
    min-height: 100px;
    border-style: dashed !important;
    border-width: 4px !important;
}

.movement-droppable .droppable.drag-over {
    background-color: rgba(255, 0, 0, 0.47) !important;
    transition: background-color 0.15s;
}

.full-width #body-content {
    max-width: unset !important;
}
</style>

<script setup>
import {ref, computed, watch, onMounted, provide, onUnmounted} from 'vue';
import axios from 'axios';
import flatpickr from 'flatpickr';
import Modal from 'bootstrap/js/dist/modal';
import { successAlert } from '@/utils';
// import { useEchoModel } from "@laravel/echo-vue";
import { echo } from "@laravel/echo-vue";
import { useMovementFormatting } from '@/composables/useMovementFormatting';
import { createDragDropContext } from '@/composables/useDragAndDrop';
import AdminBlock from '@/components/movements/components/AdminBlock.vue';
import DriverDropzone from '@/components/movements/jobs/planner/DriverDropzone.vue';
import TimeLabel from "@/components/movements/components/TimeLabel.vue";
import MoveToTodayModal from '@/components/movements/components/MoveToTodayModal.vue';
import Swal from 'sweetalert2';

// Provide drag/drop context for all nested planner dropzones/items.
createDragDropContext();

// Props
const props = defineProps({
    date: {
        type: String,
        required: false,
        default: () => new Date().toISOString().split('T')[0]
    },
    unassignedView: {
        type: Boolean,
        default: false,
    },
});

// Create drag and drop context for this planner date only.
const dragDropContext = createDragDropContext(() => internalDate.value);
const { formatDate } = useMovementFormatting();

const getDateFromQueryString = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('date');
};

const getDateString = (date) => {
    return date.toISOString().split('T')[0];
};

const getYesterday = () => {
    const date = new Date(internalDate.value ?? props.date);
    date.setDate(date.getDate() - 1);
    currentDate.value = date;
    return date;
};

const getTomorrow = () => {
    const date = new Date(internalDate.value ?? props.date);
    date.setDate(date.getDate() + 1);
    currentDate.value = date;
    return date;
};

const openUnassignedMovementsPopout = () => {
    hideUnassignedMovements.value = true;
    const popup = window.open(
        route('movements.jobs.planner.index', {date: internalDate.value, unassigned: true}),
        'planner-unassigned-popout',
        'popup=yes,width=500,height=900'
    );
    popup.focus();
}

// Reactive data
const internalDate = ref(getDateFromQueryString() ?? new Date().toISOString().split('T')[0]);
const currentDate = ref(getDateFromQueryString() ?? new Date().toISOString().split('T')[0]);

const today = ref(getDateString(new Date()));
const yesterday = ref(getDateString(getYesterday()));
const tomorrow = ref(getDateString(getTomorrow()));
const isPublished = ref(false);
const assignedMovements = ref({});
const unassignedMovements = ref([]);
const drivers = ref([]);
const unassignedMovementsGroupedByDate = ref([]);
const showCounts = ref(false);
const modalInstance = ref(null);
const selectedMovements = ref([]);
const selectText = ref('Select All');
const hideUnassignedMovements = ref(props.unassignedView);
const isUnassignedPopout =ref(props.unassignedView);
const currentPlannerChannel = ref(null);
const isHistoryRefreshInFlight = ref(false);
const lastHistoryRefreshAt = ref(0);
const plannerRequestToken = ref(0);

// Track movement IDs recently changed by THIS screen/user
const localMovementMutations = ref(new Map());

const markLocalMovementMutation = (movementIds, ttlMs = 5000) => {
    const now = Date.now();
    movementIds.forEach((id) => {
        localMovementMutations.value.set(Number(id), now + ttlMs);
    });
};

const wasLocallyMutated = (movementId) => {
    const expiry = localMovementMutations.value.get(Number(movementId));
    if (!expiry) return false;
    if (Date.now() > expiry) {
        localMovementMutations.value.delete(Number(movementId));
        return false;
    }
    return true;
};

provide('markLocalMovementMutation', markLocalMovementMutation);

// Scroll state
const scrollInterval = ref(null);
const scrollSpeed = ref(0);

const startScrolling = (speed) => {
    scrollSpeed.value = speed;
    // Only start the interval if it's not already running
    if (!scrollInterval.value) {
        scrollInterval.value = setInterval(() => {
            window.scrollBy(0, scrollSpeed.value / 2);
        }, 20); // 20ms interval for smooth scrolling
    }
};

const stopScrolling = () => {
    if (scrollInterval.value) {
        clearInterval(scrollInterval.value);
        scrollInterval.value = null;
    }
    scrollSpeed.value = 0;
};

const handleGlobalDragOver = (event) => {
    // Only scroll if we are actually dragging something
    // Also filter out invalid events (0,0) which can happen when dragging over un-droppable areas in some browsers
    if (!dragDropContext.state.isDragging || (event.clientX === 0 && event.clientY === 0)) {
        stopScrolling();
        return;
    }

    // Update ghost position globally to ensure it follows mouse even over non-drop zones
    dragDropContext.updateGhostPosition(event);

    const threshold = 600;
    const deadzone = 300;
    const maxSpeed = 500;

    if (event.clientY < ((window.innerHeight / 2) - deadzone)) {
        const speed = Math.max(5, (threshold - event.clientY) / threshold * maxSpeed);
        startScrolling(-speed);
    } else if (event.clientY > ((window.innerHeight / 2) + deadzone)) {
        const speed = Math.max(5, (event.clientY - (window.innerHeight - threshold)) / threshold * maxSpeed);
        startScrolling(speed);
    } else {
        stopScrolling();
    }
};

// Template refs
const modal = ref(null);
const movementCheckbox = ref([]);

// Computed properties
const isToday = computed(() => internalDate.value === today.value);
const isYesterday = computed(() => internalDate.value === yesterday.value);
const isInPast = computed(() => new Date(internalDate.value) < new Date(today.value));
const isInFuture = computed(() => new Date(internalDate.value) > new Date(today.value));
const isTomorrow = computed(() => internalDate.value === tomorrow.value);
const dragStorageKey = computed(() => `planner-cross-window-drag:${internalDate.value}`);
const moveStorageKey = computed(() => `planner-cross-window-move:${internalDate.value}`);

const leavePlannerUpdates = () => {
    if (!currentPlannerChannel.value) return;
    echo().leave(currentPlannerChannel.value);
    currentPlannerChannel.value = null;
};

// /*
//  * This is defined in the Movement Model broadcastOn method
//  */
// const subscribeMovementUpdates = () => {
//
//     [...Object.values(assignedMovements.value).flat(), ...unassignedMovements.value].forEach(movement => {
//         useEchoModel(
//             "App.Models.Movements.Movement",
//             movement.id,
//             ["MovementUpdated"],
//             onMovementUpdated
//         ).listen();
//     });
// };


/*
 * This is defined in the Movement Model broadcastOn method
 */
const subscribePlannerUpdates = () => {
    const channelName = `planner.${internalDate.value}`;

    if (currentPlannerChannel.value === channelName) {
        return;
    }

    leavePlannerUpdates();
    currentPlannerChannel.value = channelName;

    echo().private(channelName)
        .listen('.MovementUpdated', (payload) => onMovementUpdated(payload))
        .listen('.MovementDeleted', (payload) => onMovementDeleted(payload))
        .listen('.EvidenceCreated', (payload) => onEvidenceUpdated(payload))
        .listen('.EvidenceUpdated', (payload) => onEvidenceUpdated(payload))
        .listen('.PublishedDayCreated', () => isPublished.value = true)
        .listen('.PublishedDayDeleted', () => isPublished.value = false);

};

/**
 * Update in place when a movement is updated via Web Socket.
 * This allows Movements to be updated whilst their modal is open.
 *
 * It MUST be updated in place. Re-assigning the array will break reactivity.
 *
 * @param updated
 */
const onMovementUpdated = ({ model: updated }) => {
    const localChange = wasLocallyMutated(updated.id);
    const updatedDate = updated.collection_date ? String(updated.collection_date).slice(0, 10) : null;

    if (!localChange && updatedDate === internalDate.value) {
        updated._websocket_updated_at = Date.now();
    } else if ('_websocket_updated_at' in updated) {
        delete updated._websocket_updated_at;
    }

    const updatedDriverId = updated.driver_id ? Number(updated.driver_id) : null;

    let currentDriverId = Object.keys(assignedMovements.value).find(id =>
        (assignedMovements.value[id] || []).some(m => Number(m.id) === Number(updated.id))
    );

    let isInUnassigned = !currentDriverId && (unassignedMovements.value || []).some(m => Number(m.id) === Number(updated.id));

    if (currentDriverId || isInUnassigned) {
        if (updatedDate !== internalDate.value) {
            if (currentDriverId) {
                assignedMovements.value[currentDriverId] = (assignedMovements.value[currentDriverId] || []).filter(m => Number(m.id) !== Number(updated.id));
            } else {
                unassignedMovements.value = (unassignedMovements.value || []).filter(m => Number(m.id) !== Number(updated.id));
            }
            return;
        }

        if (currentDriverId) {
            const index = (assignedMovements.value[currentDriverId] || []).findIndex(m => Number(m.id) === Number(updated.id));

            if (updatedDriverId && updatedDriverId === Number(currentDriverId)) {
                assignedMovements.value[currentDriverId][index] = { ...assignedMovements.value[currentDriverId][index], ...updated };
            } else {
                const [movement] = assignedMovements.value[currentDriverId].splice(index, 1);

                if (updatedDriverId) {
                    if (!assignedMovements.value[updatedDriverId]) assignedMovements.value[updatedDriverId] = [];
                    const exists = assignedMovements.value[updatedDriverId].some(m => Number(m.id) === Number(updated.id));
                    if (!exists) assignedMovements.value[updatedDriverId].push({ ...movement, ...updated });
                } else {
                    const exists = (unassignedMovements.value || []).some(m => Number(m.id) === Number(updated.id));
                    if (!exists) unassignedMovements.value.push({ ...movement, ...updated });
                }
            }

            if (updatedDriverId && assignedMovements.value[updatedDriverId]) {
                assignedMovements.value[updatedDriverId].sort((a, b) =>
                    (a.planned_position == null ? Number.POSITIVE_INFINITY : Number(a.planned_position)) -
                    (b.planned_position == null ? Number.POSITIVE_INFINITY : Number(b.planned_position))
                );
            }
        } else {
            const index = (unassignedMovements.value || []).findIndex(m => Number(m.id) === Number(updated.id));

            if (!updatedDriverId) {
                unassignedMovements.value[index] = { ...unassignedMovements.value[index], ...updated };
            } else {
                const [movement] = unassignedMovements.value.splice(index, 1);
                if (!assignedMovements.value[updatedDriverId]) assignedMovements.value[updatedDriverId] = [];
                const exists = assignedMovements.value[updatedDriverId].some(m => Number(m.id) === Number(updated.id));
                if (!exists) assignedMovements.value[updatedDriverId].push({ ...movement, ...updated });

                assignedMovements.value[updatedDriverId].sort((a, b) =>
                    (a.planned_position == null ? Number.POSITIVE_INFINITY : Number(a.planned_position)) -
                    (b.planned_position == null ? Number.POSITIVE_INFINITY : Number(b.planned_position))
                );
            }
        }
    } else {
        if (updatedDate === internalDate.value) {
            if (updatedDriverId) {
                if (!assignedMovements.value[updatedDriverId]) assignedMovements.value[updatedDriverId] = [];
                const exists = assignedMovements.value[updatedDriverId].some(m => Number(m.id) === Number(updated.id));
                if (!exists) assignedMovements.value[updatedDriverId].push(updated);

                assignedMovements.value[updatedDriverId].sort((a, b) =>
                    (a.planned_position == null ? Number.POSITIVE_INFINITY : Number(a.planned_position)) -
                    (b.planned_position == null ? Number.POSITIVE_INFINITY : Number(b.planned_position))
                );
            } else {
                const exists = (unassignedMovements.value || []).some(m => Number(m.id) === Number(updated.id));
                if (!exists) unassignedMovements.value.push(updated);
            }
        }
    }
};

/**
 * Remove movement from UI when it is deleted via Web Socket.
 *
 * @param deleted
 */
const onMovementDeleted = ({ model: deleted }) => {
    let currentDriverId = Object.keys(assignedMovements.value).find(id =>
        (assignedMovements.value[id] || []).some(m => Number(m.id) === Number(deleted.id))
    );

    if (currentDriverId) {
        assignedMovements.value[currentDriverId] = (assignedMovements.value[currentDriverId] || [])
            .filter(m => Number(m.id) !== Number(deleted.id));
    } else {
        unassignedMovements.value = (unassignedMovements.value || [])
            .filter(m => Number(m.id) !== Number(deleted.id));
    }
};

// /*
//  * This is defined in the Evidence Model broadcastOn method
//  */
// const subscribeEvidenceUpdates = () => {
//     const allMovements = [...Object.values(assignedMovements.value).flat(), ...unassignedMovements.value];
//     allMovements.forEach(movement => {
//         useEchoModel(
//             "App.Models.Movements.Movement",
//             movement.id,
//             ["EvidenceCreated", "EvidenceUpdated"],
//             onEvidenceUpdated
//         ).listen();
//     });
// };

/**
 * Updates the Evidence in a Model when the Evidence is created or updated.
 * This allows the Movement modal to show the evidence without needing a refresh.
 *
 * It MUST be updated in place. Re-assigning the array will break reactivity.
 *
 * @param evidence
 */
const onEvidenceUpdated = ({ model: evidence }) => {
    const localChange = wasLocallyMutated(evidence.movement_id);
    const evidenceDate = evidence?.movement?.collection_date
        ? String(evidence.movement.collection_date).slice(0, 10)
        : null;

    // Search in assigned movements (grouped by driver ID)
    let target = Object.values(assignedMovements.value).flat().find(m => m.id === evidence.movement_id);

    // If not found in assigned, search in unassigned
    if (!target) {
        target = unassignedMovements.value.find(m => m.id === evidence.movement_id);
    }

    // If not found in assigned, search in unassigned
    if (!target) {
        target = unassignedMovements.value.find(m => m.id === evidence.movement_id);
    }if (!target) {
        console.warn("Could not find movement for evidence", evidence);
        return;
    }

    let updatedMovement;

    if (localChange) {
        const { _websocket_updated_at, ...movementWithoutHighlightTimestamp } = evidence.movement || {};
        updatedMovement = movementWithoutHighlightTimestamp;
    } else {
        updatedMovement = { ...evidence.movement };

        if (evidenceDate === internalDate.value) {
            updatedMovement._websocket_updated_at = Date.now();
        }
    }

    Object.assign(target, updatedMovement);
};

const getIndexDataRoute = (date) => {
    return route('api.movements.jobs.planner.index', { date: date });
};

const fetchDefaultState = () => {
    const requestToken = ++plannerRequestToken.value;
    const cacheBust = Date.now();

    return axios.get(getIndexDataRoute(internalDate.value), {
        params: { _ts: cacheBust },
        headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            Pragma: 'no-cache',
            Expires: '0',
        },
    })
        .then(response => {
            if (requestToken !== plannerRequestToken.value) {
                return;
            }

            const movements = response.data.assigned_movements;
            // Ensure every driver has at least an empty array so the template is bound to something reactive
            response.data.drivers.forEach(driver => {
                if (!movements[driver.id]) {
                    movements[driver.id] = [];
                }
            });
            assignedMovements.value = movements;
            unassignedMovements.value = Object.values(response.data.unassigned_movements);
            drivers.value = response.data.drivers;
            isPublished.value = !!response.data.published_check;
            showCounts.value = response.data.show_counts;
        })
        .then(() => {
            subscribePlannerUpdates();
        })
        .catch(error => {
            console.error('Error fetching index data', error);
        });
};

const generateJobRoute = (jobId) => {
    return route('movements.jobs.show', { job: jobId });
};

const generateCustomerRoute = (customerId) => {
    return route('movements.customers.show', { customer: customerId });
};

const generateMessagesToDriversRoute = () => {
    return route('movements.jobs.planner.messages', { date: internalDate.value });
};

const generateExportRoute = () => {
    return route('movements.jobs.planner.export', { date: internalDate.value });
};

const generateMapViewRoute = () => {
    return route('movements.jobs.planner.map', { date: internalDate.value });
};

const showModal = () => {
    modalInstance.value.show();
};

const selectAllMovements = () => {
    const checkboxes = movementCheckbox.value;
    const allChecked = checkboxes.every(checkbox => checkbox.checked);

    if (allChecked) {
        checkboxes.forEach(checkbox => {
            checkbox.checked = false;
        });

        selectedMovements.value = []

        selectText.value = 'Select All';
        return;
    }

    checkboxes.forEach(checkbox => {
        checkbox.checked = true;
    });

    selectedMovements.value = Array.from(new Set([
        ...selectedMovements.value,
        ...checkboxes.map(checkbox => checkbox.value),
    ]));

    selectText.value = 'Deselect All';
};

const selectSpecificDateMovements = (date) => {
    const checkboxes = movementCheckbox.value;
    const specificCheckboxes = checkboxes.filter(checkbox => checkbox.getAttribute('data-date') === date);

    const allChecked = specificCheckboxes.every(checkbox => checkbox.checked);

    if (allChecked) {
        const specificValues = new Set(specificCheckboxes.map(checkbox => Number(checkbox.value)));
        specificCheckboxes.forEach(checkbox => {
            checkbox.checked = false;
        });

        selectedMovements.value = selectedMovements.value.filter(
            movementId => !specificValues.has(Number(movementId))
        );
        return;
    }

    specificCheckboxes.forEach(checkbox => {
        checkbox.checked = true;
    });

    selectedMovements.value = Array.from(new Set([
        ...selectedMovements.value,
        ...specificCheckboxes.map(checkbox => checkbox.value),
    ]));
};

const setDate = (date) => {
    window.location.href = route('movements.jobs.planner.index', { date: date });
};

/**
 * Used by the Move to Today modal to get all unassigned movements grouped by date.
 */
const getUnassignedMovementsGroupedByDate = () => {
    const cacheBust = Date.now();

    return axios.get(route('api.movements.jobs.planner.unassigned-movements-grouped-by-date'), {
        params: { _ts: cacheBust },
        headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            Pragma: 'no-cache',
            Expires: '0',
        },
    })
        .then(response => {
            unassignedMovementsGroupedByDate.value = response.data;
        }).catch(error => {
        console.log(error);
    });
};

// This is for the Move to Today modal
const moveUnassignedMovementsToToday = () => {
    if (!selectedMovements.value.length) {
        Swal.fire({
            toast: true,
            icon: 'error',
            title: 'No Movements Selected',
            timerProgressBar: true,
            position: 'top-end',
            timer: 3000,
            width: '600px',
            showConfirmButton: false,
        });
        return;
    }

    const movedIds = selectedMovements.value.map(id => Number(id));
    markLocalMovementMutation(movedIds);

    axios.post(route('api.movements.jobs.planner.move-to-today'), { 'movements': selectedMovements.value })
        .then(response => {
            successAlert(response.data.title, 'Success');

            unassignedMovements.value = (unassignedMovements.value || [])
                .filter(m => !movedIds.includes(Number(m.id)));

            getUnassignedMovementsGroupedByDate();
            selectedMovements.value = [];

            modalInstance.value.hide();
        }).catch(error => {
        console.log(error);
    });
};

const togglePublish = (evt) => {
    evt.target.disabled = true;

    const newState = isPublished.value;

    const publishRoute = newState ? route('api.movements.jobs.planner.publish') : route('api.movements.jobs.planner.unpublish');

    axios.post(
        publishRoute,
        {
            date: internalDate.value,
            published: newState
        }
    )
        .then(() => {
            successAlert(
                `Movements for ${internalDate.value} ` + (newState ? 'Published' : 'Unpublished'),
                'Success'
            );
        })
        .catch((errors) => {
            // Revert the toggle in the UI
            isPublished.value = !newState;

            Swal.fire({
                toast: true,
                icon: 'error',
                title: 'Could not update publish state',
                timerProgressBar: true,
                position: 'top-end',
                timer: 4000,
                width: '500px',
                showConfirmButton: false
            });
        })
        .finally(() => {
            evt.target.disabled = false;
        });
};



const refreshFromUrlAndServer = () => {
    const now = Date.now();
    if (isHistoryRefreshInFlight.value || (now - lastHistoryRefreshAt.value) < 500) {
        return;
    }

    isHistoryRefreshInFlight.value = true;
    lastHistoryRefreshAt.value = now;

    const urlDate = getDateFromQueryString() ?? getDateString(new Date());

    // keep local date refs aligned with current URL
    if (internalDate.value !== urlDate) {
        internalDate.value = urlDate;
        currentDate.value = urlDate;
    }

    // reset local-only transient indicators if needed
    localMovementMutations.value.clear();

    // always reload authoritative state
    Promise.all([
        fetchDefaultState(),
        getUnassignedMovementsGroupedByDate(),
    ]).finally(() => {
        isHistoryRefreshInFlight.value = false;
    });
};

const onPageShow = (event) => {
    const navEntries = performance.getEntriesByType('navigation');
    const navType = navEntries.length ? navEntries[0].type : 'unknown';

    // Some browsers restore from history without setting persisted reliably.
    if (event.persisted || navType === 'back_forward') {
        refreshFromUrlAndServer();
    }
};

const onHistoryNav = () => {
    // Delay one tick so URL/querystring are definitely settled.
    setTimeout(() => refreshFromUrlAndServer(), 0);
};

// Watchers
watch(internalDate, (newVal, oldVal) => {
    if (newVal !== oldVal) {
        setDate(newVal);
    }
});

// Lifecycle hooks
onMounted(() => {
    document.querySelector('#body').classList.add('full-width');

    flatpickr('.js-flatpickers', {
        dateFormat: "Y-m-d",
        enableTime: false,
        altInput: true,
    });

    flatpickr('.flatpicker-time-only', {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        altInput: true,
    });


    fetchDefaultState();

    // Add global drag event listeners for scrolling
    window.addEventListener('dragover', handleGlobalDragOver);
    window.addEventListener('dragend', stopScrolling);
    window.addEventListener('drop', stopScrolling);
    window.addEventListener('pageshow', onPageShow);
    window.addEventListener('popstate', onHistoryNav)

    // Used for assigning past movements to today
    getUnassignedMovementsGroupedByDate();

    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    });

    const modalElement = modal.value;
    modalInstance.value = new Modal(modalElement);
    // Subscribe to Evidence events for all movements
    // subscribeEvidenceUpdates();
});

onUnmounted(() => {
    window.removeEventListener('dragover', handleGlobalDragOver);
    window.removeEventListener('dragend', stopScrolling);
    window.removeEventListener('drop', stopScrolling);
    window.removeEventListener('pageshow', onPageShow);
    window.removeEventListener('popstate', onHistoryNav);
    stopScrolling();
    leavePlannerUpdates();
});
</script>
